<template>
  <el-dialog
    custom-class="chat-robot-clear-msg-dialog common-dialog"
    title="删除对话记录"
    :append-to-body="true"
    :visible.sync="showDialog"
    :show-close="false"
  >
    <div class="content">是否确定要删除对话记录？</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClear">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ClearMessages',
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    handleClose() {
      this.showDialog = false
    },
    handleClear() {
      let self = this
      let params = {
        uid: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)
      }
      this.$apis.chatrobot
        .clearMessages(params)
        .then(result => {
          self.$message.success('清除会话成功！')
          self.showDialog = false
          self.$emit('clearSuccess')
        })
        .catch(err => {
          console.log(err)
          self.$message.warning('清除会话出错，请稍后再试！')
          self.showDialog = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/adaptation';

.chat-robot-clear-msg-dialog {
  /deep/ &.el-dialog {
    width: var(--common-dialog-width);

    .el-dialog__body {
      margin-bottom: var(--base-size-16);
    }
  }

  .content {
    text-align: center;
  }
}

:global(.el-dialog.chat-robot-clear-msg-dialog) {
  @include adaptation(
    (
      --chat-robot-clear-msg-dialog-height: 158px
    )
  );
  margin-top: calc((100vh - var(--chat-robot-clear-msg-dialog-height)) / 2) !important;
}
</style>
